"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { USER_PAGE_TAB_META, UserPageTabType } from "./UserPageTabs";
import Link from "next/link";
import { useParams, useSearchParams } from "next/navigation";
export default function UserPageTab(t0) {
  const $ = _c(26);
  const {
    tab,
    parentRef,
    activeTab
  } = t0;
  const params = useParams();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== params?.user) {
    t1 = params?.user?.toString();
    $[0] = params?.user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOrWallet = t1;
  const path = `/${handleOrWallet}/${USER_PAGE_TAB_META[tab].route}`;
  const [isActive, setIsActive] = useState(tab === activeTab);
  let t2;
  if ($[2] !== activeTab || $[3] !== tab) {
    t2 = () => {
      setIsActive(tab === activeTab);
    };
    $[2] = activeTab;
    $[3] = tab;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== activeTab) {
    t3 = [activeTab];
    $[5] = activeTab;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t2, t3);
  const [classes, setClasses] = useState(isActive ? "tw-border-primary-400 tw-border-solid tw-border-x-0 tw-border-t-0 tw-text-iron-100 tw-whitespace-nowrap tw-border-b-2 tw-font-semibold tw-py-4 tw-px-1" : "tw-border-transparent tw-text-iron-500 hover:tw-border-gray-300 hover:tw-text-iron-100 tw-whitespace-nowrap tw-border-b-2 tw-py-4 tw-px-1 tw-transition tw-duration-300 tw-ease-out");
  const ref = useRef(null);
  let t4;
  if ($[7] !== parentRef) {
    t4 = () => {
      if (!parentRef.current || !ref.current) {
        return true;
      }
      const parentRect = parentRef.current.getBoundingClientRect();
      const rect = ref.current.getBoundingClientRect();
      const parentRight = parentRect.right;
      const parentLeft = parentRect.left;
      const elementRight = rect.right;
      const elementLeft = rect.left;
      return elementRight <= parentRight && elementLeft >= parentLeft;
    };
    $[7] = parentRef;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const isVisibleInViewportSide = t4;
  let t5;
  if ($[9] !== isActive || $[10] !== isVisibleInViewportSide) {
    t5 = () => {
      setClasses(isActive ? "tw-border-primary-400 tw-border-solid tw-border-x-0 tw-border-t-0 tw-text-iron-100 tw-whitespace-nowrap tw-border-b-2 tw-font-semibold tw-py-4 tw-px-1" : "tw-border-transparent tw-text-iron-500 hover:tw-border-gray-300 hover:tw-text-iron-100 tw-whitespace-nowrap tw-border-b-2 tw-py-4 tw-px-1 tw-transition tw-duration-300 tw-ease-out");
      if (ref.current && isActive && !isVisibleInViewportSide()) {
        ref.current.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center"
        });
      }
    };
    $[9] = isActive;
    $[10] = isVisibleInViewportSide;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== isActive) {
    t6 = [isActive];
    $[12] = isActive;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  useEffect(t5, t6);
  let t7;
  if ($[14] !== searchParams) {
    t7 = searchParams?.get("address") ? {
      address: searchParams.get("address")
    } : {};
    $[14] = searchParams;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== path || $[17] !== t7) {
    t8 = {
      pathname: path,
      query: t7
    };
    $[16] = path;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = `${isActive ? "tw-pointer-events-none" : ""}  tw-no-underline tw-leading-4 tw-p-0 tw-text-base tw-font-semibold`;
  const t10 = USER_PAGE_TAB_META[tab];
  let t11;
  if ($[19] !== classes || $[20] !== t10.title) {
    t11 = <div className={classes}>{t10.title}</div>;
    $[19] = classes;
    $[20] = t10.title;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t8 || $[24] !== t9) {
    t12 = <Link ref={ref} href={t8} className={t9}>{t11}</Link>;
    $[22] = t11;
    $[23] = t8;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
}